class InfinitePagination extends HTMLElement {
  constructor() {
    super();

    this.paginationEvent = this.dataset.paginationEvent;
    this.url = this.dataset.nextPage;
    this.button = document.getElementById('loadMore');
    this.productLoaded = document.getElementById('LoadMoreCurrent');
    this.loader = document.querySelector('.pagination-loader');

    if (this.button && this.paginationEvent === 'load_more') {
      this.button.addEventListener('click', () => {
        this.fetchProducts();
      });
    } else if (this.paginationEvent === 'infinite') {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        if (this.url === '') observer.unobserve(this.button);

        this.fetchProducts();
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this.button);
    }
  }

  updateLoadedProductNumber() {
    if (
      Number(this.productLoaded.textContent) + Number(this.productLoaded.dataset.loadMoreSize) >=
      Number(this.productLoaded.dataset.loadMoreTotalSize)
    ) {
      this.productLoaded.textContent = Number(this.productLoaded.dataset.loadMoreTotalSize);
    } else {
      this.productLoaded.textContent =
        Number(this.productLoaded.dataset.loadMoreSize) + Number(this.productLoaded.textContent);
    }
  }

  fetchProducts() {
    if (this.url != '') {
      this.loader.removeAttribute('hidden');
      fetch(this.url)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const products = html.querySelector('#product-grid').innerHTML;

          if (products.length) {
            this.querySelector('#product-grid').insertAdjacentHTML('beforeend', products);
          }

          history.pushState({ scrollTop: document.body.scrollTop }, '', this.url);
          this.url = html.querySelector('infinite-pagination').dataset.nextPage;
          if (this.url === '') this.button.setAttribute('hidden', '');
          this.loader.setAttribute('hidden', '');
          this.updateLoadedProductNumber();
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }
}

customElements.define('infinite-pagination', InfinitePagination);
